var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconImage24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 8.58a1 1 0 00-.29-.7l-5.42-5.42a1 1 0 00-.7-.29H2a2 2 0 00-2 2v16a2 2 0 002 2h20a2 2 0 002-2V8.58zm-2 11.09a.5.5 0 01-.5.5h-19a.5.5 0 01-.5-.5v-15a.5.5 0 01.5-.5H17a.49.49 0 01.36.15l4.53 4.53a.49.49 0 01.11.32v10.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3 10.17a2 2 0 100-4 2 2 0 000 4zm5.42.68a.491.491 0 00-.84 0l-2.43 3.88a.271.271 0 01-.21.12.24.24 0 01-.21-.12l-.87-1.38a.49.49 0 00-.666-.175.51.51 0 00-.184.175l-2.77 4.44a.25.25 0 00.093.344.26.26 0 00.127.036h12.1a.26.26 0 00.253-.255.25.25 0 00-.033-.125l-4.36-6.94z"
  })));
}
export default SvgIconImage24;